import { getLocale } from "../runtime";

const sv_shopby = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Handla efter`
};

const shopby = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_shopby(inputs)
	return "shopBy";
};

export { shopby as "shopBy" };